import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../base-api.service';
import {FamiliesEventsModelService} from '../../Models/Events/families-events-model.service';

@Injectable({
  providedIn: 'root'
})
export class FamiliesEventsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: FamiliesEventsModelService
  ) {
    super(injector);
  }


  /**
   * Obtener las familias de los eventos
   *
   */
  public getFamiliesEvents(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('events/families/list', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }

}
